import { createStyles, makeStyles } from '@material-ui/core';

export const useRadioGroupStyles = makeStyles(() =>
    createStyles({
        root: {
            gap: 18,
            display: 'flex',
            flexDirection: 'column'
        },
        optionsContainer: {
            gap: 16,
            display: 'flex',
            alignItems: 'center'
        }
    })
);
